// A hikaru dorodango: a ball of mud polished by hand into a mirror. Polish
// is kept per vertex of the rest mesh, 0 for rough mud and 1 for a mirror.
// Only rubbing polishes, in proportion to how far the finger slides, and each
// spot gets harder to improve the shinier it is. Fine dry powder (sara-ko)
// fills the tiny pores, so rubbing over it polishes faster, and the rubbing
// wipes it away. Polished all over, it shines.
export class DangoPolish{
  // reachable(x,y,z): the skin a finger can rub from where it sits; the shine
  // is judged there (the bottom rests on its tray).
  constructor({rest,radius,reachable=()=>true}){
    this.rest=rest;this.radius=radius;const n=rest.length/3;this.polish=new Float32Array(n);this.powder=new Float32Array(n);this.shone=false;
    this.reach=Uint8Array.from({length:n},(_,i)=>reachable(rest[i*3],rest[i*3+1],rest[i*3+2])?1:0);
  }
  get mean(){let s=0,n=0;for(let i=0;i<this.polish.length;i++)if(this.reach[i]){s+=this.polish[i];n++;}return n?s/n:0;}
  near(point,reach,fn){
    const p=this.rest,r2=reach*reach;
    for(let i=0;i<this.polish.length;i++){const d2=(p[i*3]-point[0])**2+(p[i*3+1]-point[1])**2+(p[i*3+2]-point[2])**2;if(d2<r2)fn(i,Math.exp(-d2/(r2*.4)));}
  }
  // Rub at a point, the finger having slid `distance` this step.
  rub(point,distance,dt){
    const events=[];if(distance<=1e-5)return events;
    const k=Math.min(.1,distance/this.radius*.65);
    this.near(point,this.radius*.42,(i,w)=>{
      const boost=1+1.5*this.powder[i];
      this.polish[i]=Math.min(1,this.polish[i]+k*w*boost*(1-this.polish[i])**.6);
      this.powder[i]=Math.max(0,this.powder[i]-distance/this.radius*.6*w);
    });
    if(!this.shone&&this.mean>.8){this.shone=true;events.push("shine");}
    return events;
  }
  // A pinch of dry powder over the top and front.
  dust(){
    const p=this.rest;let cy=0;for(let i=1;i<p.length;i+=3)cy+=p[i];cy/=p.length/3;
    // Only where a finger can rub it off again.
    for(let i=0;i<this.powder.length;i++){const up=(p[i*3+1]-cy)/this.radius,front=p[i*3+2]/this.radius;if(this.reach[i]&&up+front*.6>-.2)this.powder[i]=Math.min(1,this.powder[i]+.9);}
  }
  reset(){this.polish.fill(0);this.powder.fill(0);this.shone=false;}
}
